import {
  collectNodeSourceOptions,
  NodeSourceOption,
} from '../../networkNodeCopyUtils';
import {
  createDefaultDepartment,
  DepartmentFormValues,
  NetworkNodeFieldPath,
  NetworkNodeFormValues,
} from '../../../types';

export type DepartmentSourceOption = NodeSourceOption;

export const isFilledDepartment = (d: DepartmentFormValues) =>
  Boolean(d.name?.trim() && d.icon && d.color);

const getFilledDepartments = (departments: DepartmentFormValues[] = []) =>
  departments.filter(isFilledDepartment);

export function collectDepartmentSourceOptions(
  network: NetworkNodeFormValues[],
  currentPath: NetworkNodeFieldPath,
): DepartmentSourceOption[] {
  return collectNodeSourceOptions(
    network,
    currentPath,
    node => node.departments ?? [],
    items => getFilledDepartments(items).length > 0,
  );
}

export function cloneDepartmentsFromSource(
  source: DepartmentFormValues[],
): DepartmentFormValues[] {
  return getFilledDepartments(source).map(d =>
    createDefaultDepartment({
      name: d.name,
      icon: d.icon,
      color: d.color,
    }),
  );
}
